import React, { useState, useEffect } from "react";
import ShareMessageModal from './ShareMessageModal';
import { Validation } from '../../utils/validation';
import './Modal.css';

const CommonShareModal = ({ 
    isShow, 
    onClose, 
    onShare, 
    showShareMessageModal,
    onCloseShareMessage,
    successMessage,
    errorMessage
}) => {

    const [fields, setFields] = useState({});
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isShow) {
            setFields({});
            setErrors({});
        }
    }, [isShow]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields({ ...fields, [name]: value });
        setErrors({});
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let errors = Validation(fields,['email']);
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return;
        }

        onShare(fields);
    };

    return (
        <React.Fragment>

            {isShow && (
                <div className="motor-modal-overlay">
                    <div className="motor-modal-content">
                        <form className="motor-error-report-form d-flex flex-column gap-3" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="email" 
                                    id="email"
                                    value={fields.email || ''}
                                    onChange={handleChange}
                                    style={{ backgroundColor: '#E4E4E4' }}
                                />
                                {errors.email && (
                                    <div className="text-danger">{errors.email}</div>
                                )}
                            </div>
                            <div className="d-flex w-100 justify-content-evenly gap-4">
                                <button
                                    type="button"
                                    className="btn btn-secondary w-50"
                                    onClick={onClose}
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="submit-button w-50 submit-error-report"
                                >
                                    Share
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showShareMessageModal && (
                <ShareMessageModal
                    isShow={showShareMessageModal}
                    successMessage={successMessage}
                    errorMessage={errorMessage}
                    onClose={onCloseShareMessage}
                />
            )}

        </React.Fragment>
    )
}

export default CommonShareModal;